
.concourse-person-selector .person-selector {
  display: flex;
  align-items: center;
  padding: 4px;
}

.concourse-person-selector ion-content::part(scroll) {
  padding: 0;
}

.concourse-person-selector .people-chips {
  width: 100%;
}

.concourse-person-selector .selector-item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: 0.5rem;
}

.concourse-person-selector .selector-item:hover {
  background-color: #333;
  cursor: pointer;
}

.concourse-person-selector .selector-item.selected {
  background-color: #333;
}

.concourse-person-selector .selector-item .icon ion-icon {
  border: 1px solid var(--background-color-step-150);
  background-color: var(--background-color-step-150);
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
}

.concourse-person-selector .selector-item .info {
  flex: 1;
}

.concourse-person-selector .selector-item .info h3 {
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
}

.concourse-person-selector .selector-item .info p {
  margin: 0;
  font-size: 12px;
  color: var(--ion-color-medium);
}

.concourse-person-selector .team-arrow {
  color: var(--ion-color-medium);
  font-size: 18px;
  /*position: absolute; wtf dude
  right: 20px;*/
  margin-right: 20px;
}
